import angular from 'angular';
import { CompanyStatusInquiryReportsComponent } from './company-status-inquiry-reports.component';
import { InquiryAnalyticsDashboardComponent } from './inquiry-analytics-dashboard.component';
import { PayChequeInquiryReportsComponent } from './pay-cheque-inquiry-reports.component';

export const InquiryAnalyticsModule = angular
    .module("apex.mainApp.inquiryAnalytics", [])
    .component("apexCompanyStatusInquiryReports", CompanyStatusInquiryReportsComponent)
    .component("apexInquiryAnalyticsDashboard", InquiryAnalyticsDashboardComponent)
    .component("apexPayChequeInquiryReports", PayChequeInquiryReportsComponent)
    .name;
